export default __webpack_public_path__ + "static/media/FC-01.25653c12.png";